import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-ats-integrations',
    templateUrl: './ats-integrations.component.html',
    styleUrls: ['./ats-integrations.component.scss'],
    standalone: false
})
export class AtsIntegrationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
